<template>
  <div>
    <ValidationObserver ref="observer" style="position: absolute;">
      <v-row no-gutters align="center">
        <v-col cols="12" sm="12" md="6" class="pt-8">
          <modal-cadu @input="$emit('close')" :close="close" :width="1131.52" v-model="show">
            <div slot="all" class="py-10 px-10">
              <div slot="header">
                <div class="font-primaria headline font-weight-bold pb-4" style="color: #00995d;">
                  {{ actionName.toUpperCase() }} CERTIFICAÇÃO/SELO
                </div>
              </div>

              <div slot="body" class="body-line">
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <validation-provider name="nomeSeloCertificacao" mode="eager" rules="required" v-slot="{ errors }">
                      <autocomplete-cadu
                        :errorMessage="errors[0]"
                        title="Nome Certificação/Selo"
                        :disabled="!canEdit()"
                        v-model="cloneObjSeloCertificado.tipoSelo.nome"
                        :items="listaCertificadoSelo.map((el) => el.nome)"
                        :colorText="$vuetify.theme.themes.light.fontColor1"
                        :max="'50'"
                        @index="seloIndex"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <validation-provider
                      name="instituicaoResponsavel"
                      mode="eager"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <autocomplete-cadu
                        :errorMessage="errors[0]"
                        title="Instituição Responsável"
                        :disabled="!canEdit()"
                        v-model="cloneObjSeloCertificado.instituicaoResponsavel.nome"
                        :items="listaInsituicoes.map((el) => el.nome)"
                        :colorText="$vuetify.theme.themes.light.fontColor1"
                        :max="'50'"
                        @index="instituicaoIndex"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="12" md="2">
                    <datepicker-cadu
                      validateProviderRules="required|dateValidatorForPass"
                      :inputTitle="'Data Início'"
                      :inputValue="cloneObjSeloCertificado.dataInicio"
                      :disabled="!canEdit()"
                      @value="(value) => (cloneObjSeloCertificado.dataInicio = value)"
                      typeCalendar="date"
                      width="280"
                      :maxDate="today"
                    >
                    </datepicker-cadu>
                  </v-col>

                  <v-col cols="12" sm="12" md="2">
                    <datepicker-cadu
                      :validateProviderRules="!isCertificadoApenasAno ? 'required|dateValidator' : ''"
                      :inputTitle="'Data Fim'"
                      :inputValue="cloneObjSeloCertificado.dataFim"
                      :disabled="!canEdit()"
                      :minDate="cloneObjSeloCertificado.dataInicio"
                      @value="(value) => (cloneObjSeloCertificado.dataFim = value)"
                      typeCalendar="date"
                      width="280"
                    >
                    </datepicker-cadu>
                  </v-col>

                  <v-col cols="12" sm="12" md="2" v-if="isCertificadoApenasAno">
                    <validation-provider name="ano" mode="eager" rules="required|yearValidator" v-slot="{ errors }">
                      <input-cadu
                        :errorMessage="errors[0]"
                        title="Edição"
                        v-model="cloneObjSeloCertificado.ano"
                        :disabled="!canEdit()"
                        :colorText="$vuetify.theme.themes.light.fontColor1"
                        onlyNumber
                        :max="'4'"
                      />
                    </validation-provider>
                  </v-col>

                  <v-col cols="12" sm="12" md="3" v-if="isCertificadoUsaNivel">
                    <validation-provider name="nivelTipoSelo" mode="eager" v-slot="{ errors }">
                      <autocomplete-cadu
                        :errorMessage="errors[0]"
                        title="Nível"
                        :disabled="!canEdit()"
                        v-model="cloneObjSeloCertificado.tipoSelo.nivel"
                        :items="listaCertificadosNiveis"
                        :colorText="$vuetify.theme.themes.light.fontColor1"
                        :max="'50'"
                        @index="nivelIndex"
                      />
                    </validation-provider>
                  </v-col>

                  <v-col cols="3" v-if="action === 'view'" align-self="center" class="mt-3">
                    <checkbox-cadu v-model="cloneObjSeloCertificado.vigente" disable>
                      <div slot="text">Vigente</div>
                    </checkbox-cadu>
                  </v-col>
                </v-row>
              </div>

              <div slot="footer" class="pt-06">
                <div v-if="!canEdit()">
                  <v-row align="end" justify="end">
                    <v-col cols="auto">
                      <button-cadu @click="show = false"> <div>VOLTAR</div> </button-cadu>
                    </v-col>
                  </v-row>
                </div>

                <div v-else>
                  <div v-if="!$vuetify.breakpoint.xs">
                    <v-row align="center" justify="start">
                      <v-col cols="auto" v-if="action === 'edit'">
                        <button-cadu outline @click="verifyCancelar"> CANCELAR </button-cadu>
                      </v-col>

                      <v-col cols="auto" v-if="action === 'add'">
                        <button-cadu outline @click="show = false"> VOLTAR </button-cadu>
                      </v-col>

                      <v-row align="center" justify="end" class="mr-2 mt-2">
                        <v-col cols="auto" v-if="action === 'add'">
                          <button-cadu
                            :backColor="$vuetify.theme.themes.light.primary2"
                            block
                            class="px-4"
                            @click="finalizarAdicionar"
                          >
                            SALVAR E ADICIONAR OUTRO
                          </button-cadu>
                        </v-col>

                        <v-col cols="auto">
                          <button-cadu @click="saveCertificacaoSelo"> SALVAR </button-cadu>
                        </v-col>
                      </v-row>
                    </v-row>
                  </div>

                  <div v-else>
                    <v-row align="center" justify="center" class="mt-2">
                      <v-col cols="12" v-if="action === 'add'">
                        <button-cadu
                          :backColor="$vuetify.theme.themes.light.primary2"
                          block
                          large
                          @click="finalizarAdicionar"
                        >
                          SALVAR E ADICIONAR OUTRO
                        </button-cadu>
                      </v-col>

                      <v-col cols="12">
                        <button-cadu @click="saveCertificacaoSelo" block> SALVAR </button-cadu>
                      </v-col>
                    </v-row>

                    <v-col cols="12">
                      <button-cadu outline block @click="show = false"> CANCELAR </button-cadu>
                    </v-col>
                  </div>
                </div>
              </div>
            </div>
          </modal-cadu>
        </v-col>
      </v-row>
    </ValidationObserver>

    <modal-cancelar v-model="showModalCancelar" @cancelar-edicao="cancelarEdicao()" />
    <error-modal v-model="error" :errObj="errObj" />
  </div>
</template>

<script>
import { mask } from 'vue-the-mask'
import { cloneDeep, isEqual, assign } from 'lodash'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import moment from 'moment'

import Selo from '../../../../../services/Selos/Selo'
import InstituicaoResponsavel from '../../../../../services/Dominios/InstituicaoResponsavel'

export default {
  directives: {
    mask
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    seloCertificado: {
      type: Object,
      required: false
    },
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      close: true,
      show: this.value,
      switchAtivo: false,
      objSeloCertificado: this.seloCertificado,
      cloneObjSeloCertificado: {},
      indexSelo: -1,
      indexInstituicao: -1,
      listaTipoSelosAno: [],
      listaInsituicoes: [],
      listaCertificadoSelo: [],
      listaCertificadosNiveis: [],
      certificadoApenasAno: false,
      tokenBearer: localStorage.getItem('tokenBearer'),
      today: moment().format('DD/MM/YYYY'),
      showModalCancelar: false,
      error: false,
      errObj: {}
    }
  },
  methods: {
    instituicaoIndex(index) {
      if (index > -1) this.cloneObjSeloCertificado.instituicaoResponsavel = this.listaInsituicoes[index]
    },
    seloIndex(index) {
      if (index > -1) {
        this.cloneObjSeloCertificado.tipoSelo.nome = this.listaCertificadoSelo[index].nome
        this.cloneObjSeloCertificado.tipoSelo.id = this.listaCertificadoSelo[index].id
        this.cloneObjSeloCertificado.tipoSelo.bloqueado = this.listaCertificadoSelo[index].bloqueado
        this.certificadoApenasAno = this.listaCertificadoSelo[index].apenasAno
        this.listaCertificadosNiveis = this.listaCertificadoSelo[index].niveis
      }
    },
    nivelIndex(index) {
      if (index > -1) {
        this.cloneObjSeloCertificado.tipoSelo.nivel = this.listaCertificadosNiveis[index]
      }
    },
    verifyCancelar() {
      this.objSeloCertificado.instituicaoResponsavel.tipoDominio = this.cloneObjSeloCertificado.instituicaoResponsavel.tipoDominio
      if (!isEqual(this.objSeloCertificado, this.cloneObjSeloCertificado)) {
        this.showModalCancelar = true;
      } else {
        this.showModalCancelar = false;
        this.$emit('input', false);
      }
    },
    cancelarEdicao() {
      this.showModalCancelar = false;
      // this.$nextTick(() => {
      //   let obj = {}
      //   assign(obj, this.objSeloCertificado)
      //   this.cloneObjSeloCertificado.tipoSelo = this.objSeloCertificado.tipoSelo
      //   this.cloneObjSeloCertificado.instituicaoResponsavel = this.objSeloCertificado.instituicaoResponsavel
      //   this.cloneObjSeloCertificado.vigente = this.objSeloCertificado.vigente
      //   this.cloneObjSeloCertificado.dataFim = this.objSeloCertificado.dataFim
      //   this.cloneObjSeloCertificado.dataInicio = this.objSeloCertificado.dataInicio
      //   this.cloneObjSeloCertificado.id = this.objSeloCertificado.id
      // });
      this.$emit('input', false);
    },
    listarAutoComplete(tokenBearer) {
      this.getSelos(tokenBearer)
      this.getInstituicao(tokenBearer)
    },
    async getSelos(tokenBearer) {
      const selo = new Selo(tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      await selo.getTiposSelo().then((res) => (this.listaCertificadoSelo = res.data))
    },
    async getInstituicao(tokenBearer) {
      const instituicaoResponsavel = new InstituicaoResponsavel(tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      await instituicaoResponsavel.getInstituicao().then((res) => (this.listaInsituicoes = res.data))
    },
    async saveCertificacao() {
      this.$emit('save-certificacao-selo', this.cloneObjSeloCertificado)
      this.show = false
    },
    canEdit() {
      if (this.action === 'view') {
        return false
      } else {
        return true
      }
    },
    isVigente() {
      return moment(this.cloneObjSeloCertificado.dataFim).isAfter()
    },
    async saveCertificacaoSelo() {
      const responseValidate = await this.$refs.observer.validate()

      if (responseValidate) {
        if (this.isCertificadoApenasAno || this.dataFimIsAfterDataInicio()) {
          const objetoCertificado = this.mountObjetoCertificado()
          this.$emit('save-certificacao-selo', objetoCertificado)
        } else {
          this.errObj.error = 'Data final não pode ser igual a data inicial.'
          this.error = true
        }
      }
    },
    async finalizarAdicionar() {
      const responseValidate = await this.$refs.observer.validate()

      if (responseValidate && this.dataFimIsAfterDataInicio()) {
        const objetoCertificado = this.mountObjetoCertificado()
        this.$emit('save-certificacao-criarOutro', objetoCertificado)
      }
    },
    dataFimIsAfterDataInicio() {
      let datafim = new Date(this.formatarData(this.cloneObjSeloCertificado.dataFim))
      let datainicio = new Date(this.formatarData(this.cloneObjSeloCertificado.dataInicio))

      return datafim > datainicio
    },
    formatarData(value) {
      if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(value)) {
        return false
      }

      var parts = value.split('/')
      var day = parseInt(parts[0], 10)
      var month = parseInt(parts[1], 10)
      var year = parseInt(parts[2], 10)

      month = month > 9 ? month : '0' + month

      var formatado = `${year}-${month}-${day}`

      return formatado
    },
    mountObjetoCertificado() {
      const isVigente = this.isVigente()

      const objSeloCertificado = {
        vigente: isVigente,
        id: this.cloneObjSeloCertificado.id,
        instituicaoResponsavel: this.cloneObjSeloCertificado.instituicaoResponsavel,
        tipoSelo: this.cloneObjSeloCertificado.tipoSelo
      }

      objSeloCertificado.dataInicio = this.cloneObjSeloCertificado.dataInicio
      objSeloCertificado.dataFim = this.cloneObjSeloCertificado.dataFim

      if (this.isCertificadoUsaNivel) {
        delete objSeloCertificado.tipoSelo.niveis
        objSeloCertificado.tipoSelo.nivel = this.cloneObjSeloCertificado.tipoSelo.nivel
      }

      return objSeloCertificado
    }
  },
  computed: {
    actionName() {
      switch (this.action) {
        case 'view':
          return 'Visualizar'

        case 'edit':
          return 'Editar'

        case 'add':
          return 'Adicionar'

        default:
          return ''
      }
    },
    isCertificadoApenasAno() {
      if (this.cloneObjSeloCertificado.tipoSelo == undefined) return false

      return this.certificadoApenasAno
    },
    isCertificadoUsaNivel() {
      if (this.cloneObjSeloCertificado.tipoSelo == null || this.cloneObjSeloCertificado.tipoSelo == undefined)
        return false

      if (this.listaCertificadosNiveis.length == 0) return false

      if (this.action === 'view') return true

      return true
    }
  },
  watch: {
    show() {
      if (!this.show) {
        this.$emit('input', false)
      } else {
        this.switchAtivo = this.objSeloCertificado.vigente
        this.listarAutoComplete(this.tokenBearer)
      }
    },
    value() {
      this.show = this.value
    },
    seloCertificado() {
      this.objSeloCertificado = this.seloCertificado
      this.cloneObjSeloCertificado = cloneDeep(this.objSeloCertificado)
    }
  }
}
</script>

<style scoped>
.body-line {
  padding-bottom: 15px;
  border-bottom: 1px solid #9e9e9e80;
}
</style>
